import getBrowserInfo from 'features/adyen/helpers/getBrowserInfo'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { RootState } from 'redux/types'

import { CybersourcePostProceedBody } from './types'

interface PrepareCybersourceArgs {
  state: RootState
}

export function prepareCybersource({ state }: PrepareCybersourceArgs): CybersourcePostProceedBody {
  const { cybersourceToken, ...restValues } =
    checkoutSelectors.getCybersourceCreditCardValues(state)
  const selectedPaymentCardId = checkoutSelectors.getSelectedPaymentCardId(state)
  return {
    cybersourceData: {
      cybersourceToken,
    },
    cardPaymentId: selectedPaymentCardId,
    browserInfo: getBrowserInfo(),
    ...restValues,
  }
}
